<template>
  <section class="container">
    <div class="row">
      <div class="col-12">
        <h5>Parrainer un ami</h5>
        <p>
          Gagnez 10 € grâce à votre code de parrainage ! Partagez votre code à vos amis :
          à chaque souscription, votre filleul et vous-même serez crédités de 10 €
          sur votre cagnotte.
        </p>
      </div>
      <div class="col-12 mx-auto">
        <div class="card border-0 shadow-sm pb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-lg-9 mx-auto">
                <div
                  v-for="(n, index) in sponsored"
                  :key="n + index"
                  class="row mt-4"
                >
                  <div class="col-12">
                    <h5 class="mb-3">
                      Inviter un {{ index === 0 ? '' : 'autre' }} filleul
                    </h5>
                  </div>
                  <div class="col-12 col-md-6">
                    <v-input
                      label="Prénom"
                      placeholder="Eric"
                      :value="sponsored[index].firstName"
                      action-module="sponsorship"
                      :path="`new[${index}].firstName`"
                    />
                  </div>
                  <div class="col-12 col-md-6">
                    <v-input
                      label="Nom"
                      placeholder="Morty"
                      :value="sponsored[index].lastName"
                      action-module="sponsorship"
                      :path="`new[${index}].lastName`"
                    />
                  </div>
                  <div class="col-12 mt-2">
                    <v-input
                      label="Email"
                      placeholder="elodie@assurup.com"
                      :value="sponsored[index].email"
                      action-module="sponsorship"
                      :path="`new[${index}].email`"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-lg-9 mx-auto">
                <div
                  class="d-flex bg-blue-700 rounded-circle cursor-pointer mx-auto mb-3"
                  style="width:50px; height: 50px"
                >
                  <v-icon
                    icon="plus-white"
                    class="m-auto"
                    @click="addNewContact"
                  />
                </div>
                <v-loader
                  :disabled="!isValid"
                  :next="next"
                  title="Valider"
                  icon="arrow-white-right"
                  class="w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Input from '@/components/common/input/Input.vue';
import { validateEmail } from '@/utils/validators';

export default {
  components: {
    'v-input': Input,
  },
  data() {
    return {
      contactsNumber: 1,
      isValid: false,
    };
  },
  computed: {
    sponsored() {
      return this.$store.getters['sponsorship/new'];
    },
  },
  watch: {
    sponsored: {
      deep: true,
      handler(value) {
        this.isValid = this.isContactsValid(value);
      },
    },
  },
  mounted() {
    if (!this.sponsored.length) {
      this.addNewContact();
    }
    this.isValid = this.isContactsValid(this.sponsored);
  },
  methods: {
    addNewContact() {
      this.$store.dispatch('sponsorship/addNewEmpty');
    },
    isContactsValid(contacts) {
      if (contacts.length === 0) {
        return false;
      }
      for (let i = 0; i < contacts.length; i += 1) {
        const { firstName, lastName, email } = contacts[i];
        if (!firstName || !lastName || !validateEmail(email)) {
          return false;
        }
      }
      return true;
    },
    next() {
      return this.$router.push('/client/perks/sponsorship/message');
    },
  },
};
</script>
